module.exports = __webpack_public_path__ + "img/iphone_1.c26623f5.png";